import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedModule } from '../../shared.module';
import { ActionMenuComponent } from '../action-menu/action-menu.component';

@Component({
  selector: 'app-accordion',
  standalone: true,
  imports: [ActionMenuComponent, SharedModule],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
})
export class AccordionComponent {
  @Input() isMenuOpen: boolean = false;
  @Input() name = '';
  @Input() maxHeight = '0px';
  @Input() dataSource!: any;
  @Output() onClick = new EventEmitter();
  @Output() onEdit: EventEmitter<void> = new EventEmitter();
  @Output() onDelete: EventEmitter<void> = new EventEmitter();
  @Output() openMenu: EventEmitter<void> = new EventEmitter();
  @Output() closeAllMenu: EventEmitter<void> = new EventEmitter();

  constructor(public domSanitizer: DomSanitizer) {}
  get santizedContent() {
    return this.dataSource
      ? this.domSanitizer.bypassSecurityTrustHtml(
          this.dataSource?.content || ''
        )
      : '';
  }
}
